import { OnInit, Input, Component, NgZone } from '@angular/core';
import { StpConfigureService } from '../stp-configure.service';
import {ExtensionInterface} from '../../../models/viewer/ExtensionInterface.model'

@Component({
    selector: 'orientation-positioning',
    template: `<table class="orientation-table">
    <thead>
        <tr>
            <th colspan='2' class="header">Adjustment of position</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <table>
                <thead>
                    <tr>
                        <th colspan='2' class="header">Position</th>
                    </tr>
                </thead>
                <tbody *ngIf="position!==undefined">
                    <tr>
                        <th>X:</th>
                        <th>
                            <input type="number" step="0.01" name="fname" (change)="changePosition()" [(ngModel)]="position.x" [disabled]="extensionInterface.isVariantChoosen">[cm]</th>
                    </tr>
                    <tr>
                        <th>Y:</th>
                        <th>
                            <input type="number" step="0.01" name="fname" (change)="changePosition()" [(ngModel)]="position.y" [disabled]="extensionInterface.isVariantChoosen">[cm]</th>
                    </tr>
                    <tr>
                        <th>Z:</th>
                        <th>
                            <input type="number" step="0.01" name="fname" (change)="changePosition()" [(ngModel)]="position.z" [disabled]="extensionInterface.isVariantChoosen">[cm]</th>
                    </tr>
                </tbody>
            </table>
        </tr>
        <!-- <tr>
            <table>
                <thead>
                    <tr>
                        <th colspan='2'>Rotation</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>X:</th>
                        <th style="text-align:right">
                            <input type="number" step="0.01" name="fname" value="2.2">[cm]</th>
                    </tr>
                    <tr>
                        <th>Y:</th>
                        <th style="text-align:right">
                            <input type="number" step="0.01" name="fname" value="2.2">[cm]</th>
                    </tr>
                    <tr>
                        <th>Z:</th>
                        <th style="text-align:right">
                            <input type="number" step="0.01" name="fname" value="2.2">[cm]</th>
                    </tr>
                </tbody>
            </table>
        </tr> -->
    </tbody>
</table>`,
    styles: [`.orientation-table{top:82px;left:10px;border:solid;color:#fff;font-size:14px;width:45%}@media only screen and (max-width:1620px){.orientation-table{width:27%}input{width:116px}}.orientation-table thead{background-color:#534f53}.orientation-table tbody{background-color:#ddd;color:#000}.orientation-table table{border:2px solid #a9a9a9;margin:3px auto;width:94%;background:#d3d3d3}.orientation-table th{font-weighT:500;padding-left:10px}.orientation-table tr{text-align:center}input{text-align:right;background:#fff;height:22px;margin-right:4px}.header{color:#fff;text-align:left}`]
})
export class OrientationPositioningComponent implements OnInit {
    public extensionInterface: ExtensionInterface;
    public position;
    @Input() set ExtensionInterface (value: ExtensionInterface){
        this.extensionInterface = value;
        if (this.extensionInterface !== null) {
                this.extensionInterface.armsTranslationVector.subscribe((vector) => {
                    this.zone.run(() => {
                        this.position = vector;
                    });
                });
        }
    }

    constructor(private stpConfigureService: StpConfigureService, private zone: NgZone) { }

    ngOnInit(): void {
    }

    public changePosition() {
            this.extensionInterface.setOrientationAndPositionOfModel(this.position);
            this.extensionInterface.rewriteArms();
            const data = this.extensionInterface.prepareFullConnectorConfiguration();
            this.stpConfigureService.saveConnectorConfiguration(data).subscribe( () => {
            });
    }


}
